import { render, staticRenderFns } from "./editModel.vue?vue&type=template&id=3272dc38&scoped=true"
import script from "./editModel.vue?vue&type=script&lang=js"
export * from "./editModel.vue?vue&type=script&lang=js"
import style0 from "./editModel.vue?vue&type=style&index=0&id=3272dc38&lang=scss&scoped=true"
import style1 from "./editModel.vue?vue&type=style&index=1&id=3272dc38&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3272dc38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3272dc38')) {
      api.createRecord('3272dc38', component.options)
    } else {
      api.reload('3272dc38', component.options)
    }
    module.hot.accept("./editModel.vue?vue&type=template&id=3272dc38&scoped=true", function () {
      api.rerender('3272dc38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/auditManage/editModel.vue"
export default component.exports